module.exports = __webpack_public_path__ + "img/DSC_7708.56651691.jpg";